import React, { useRef } from 'react';
import TextButton from 'components/TextButton';
import { isProdEnv } from 'utils/constants';
import { getLocalData, setLocalData } from 'utils/localStorage';
import { isMobileDevice_DEPRECATED } from 'utils/mode';

const getDebugOkta = () => !!getLocalData('debug-okta', false);
const setDebugOkta = bool => setLocalData('debug-okta', !!bool);

const oktaDomains = [
  '@windcreek.com',
  '@arubarenaissance.com',
  '@crystalcasinos.aw',
  '@starbucks.aw',
  '@5oclocksomewhere.com',
  '@curacaorenaissance.com',
  '@carnavalcasinocuracao.com'
];

export function emailRequiresOkta(email) {
  if (!email || !isOktaRedirectEnabled()) {
    return false;
  }
  const atIndex = email.lastIndexOf('@');
  if (atIndex > 0) {
    const domain = email.slice(atIndex).toLowerCase();
    return oktaDomains.includes(domain);
  } else {
    return false;
  }
}

export function isOktaRedirectEnabled() {
  return (
    !isMobileDevice_DEPRECATED() && /* (isProdEnv() || */ getDebugOkta() /* ) */
  );
}

function ToggleOktaButton(props) {
  const textRef = useRef();
  const getText = () => (getDebugOkta() ? 'Okta Enabled' : 'Okta Disabled');
  const toggleOkta = () => setDebugOkta(!getDebugOkta());
  return (
    <TextButton
      className="debug-toggle-okta-button"
      onClick={() => {
        toggleOkta();
        textRef.current.innerHTML = getText();
      }}
    >
      <span ref={textRef} key="text">
        {getText()}
      </span>
    </TextButton>
  );
}

export function DebugToggleOktaButton(props) {
  if (isProdEnv() || isMobileDevice_DEPRECATED()) {
    return null;
  } else {
    return <ToggleOktaButton />;
  }
}
